import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-and-message',
  templateUrl: './icon-and-message.component.html',
  styleUrls: ['./icon-and-message.component.scss'],
})
export class IconAndMessageComponent implements OnInit {
  @Input() tabPosition: number = 0;

  constructor() {}

  ngOnInit(): void {}
}
